import React, { useEffect, useState } from "react";
import { Pie } from "@ant-design/plots";
import { colors } from "../../core/theme";
import { useParams } from "react-router-dom";
import Company from "../../services/CompanyServices";
import { message } from "antd";
import PropTypes from "prop-types";

const PieEnrolledUsers = ({ selectedData, onClick, loadingParent }) => {
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  const [config, setConfig] = useState({
    appendPadding: 10,
    data: null,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.8,
    label: {
      type: "outer",
      offset: "50%",
      content: "{value}",
      style: {
        textAlign: "center",
        fontSize: 14,
      },
    },
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "",
      },
    },
    legend: {
      layout: "horizontal",
      position: "bottom",
    },
    color: [colors.custom_green, colors.custom_red],
    interactions: [{ type: "element-inactive" }],
  });

  useEffect(() => {
    if (
      (selectedData.suscription !== "" || selectedData.period > 0) &&
      loadingParent === false
    ) {
      graphicPatientsActived();
    }
  }, [selectedData, loadingParent]);

  const graphicPatientsActived = async () => {
    setLoading(true);
    try {
      let response = await Company.companyEnrolledUser(id);

      setConfig((v) => ({
        ...v,
        data: [
          {
            type: "Aceptados",
            value: response.data.accepted,
          },
          {
            type: "No aceptados",
            value: response.data.not_accepted,
          },
        ],
      }));
      setLoading(false);
    } catch (error) {
      message.error(error.message);
      setLoading(false);
    }
  };

  const handleClick = (data) => {
    if (onClick) {
      onClick(data);
    }
  };
  return (
    <div className="relative" style={{ minHeight: 318, height: "100%" }}>
      {(config.data === null || loading) && (
        <div
          style={{
            height: 260,
            width: 260,
            borderRadius: 900,
            border: "24px solid lightgray",
            left: "50%",
            transform: "translateX(-50%)",
            position: "absolute",
            top: 20,
          }}
        ></div>
      )}
      {config.data !== null && !loading && (
        <Pie
          {...config}
          onEvent={(chart, event) => {
            if (event.type === "click") {
              handleClick(event.data.data);
            }
          }}
        />
      )}
    </div>
  );
};

PieEnrolledUsers.propTypes = {
  selectedData: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  loadingParent: PropTypes.bool.isRequired,
};

export default PieEnrolledUsers;
